import React, { useState, useMemo, useCallback, useEffect } from "react";
import { baseURL } from "../../constants/pathnames";
import axios from "axios";
import { useHistory } from "react-router-dom";
import moment from "jalali-moment";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import Table from "../Table/Table";
import "./ads.sass";

const Ads = (props) => {
  const { token } = useSelector((state) => state.users);
  const history = useHistory();
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  // const [filter, setFilter] = useState();
  // const [showFilter, setShowFilter] = useState(false);
  const [issearchinput, setIsSearchinput] = useState(false);
  const [searchinput, setSearchinput] = useState("");
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [activestatus, setActivestatus] = useState({
    id: 0,
    title: "کالاهای‌جدید",
    color: "#f3ba00",
  });
  const [next, setNext] = useState(null);

  const status = [
    {
      id: 0,
      title: "کالاهای‌جدید",
      color: "#f3ba00",
    },
    {
      id: 1,
      title: "کالاهای تایید شده",
      color: "#84cf4e",
    },
    {
      id: 2,
      title: "کالاهای غیرفعال",
      color: "#cf4e4e",
    },
  ];

  const columns = [
    { Header: "عنوان", accessor: "title" },
    { Header: "نام و نام خانوادگی", accessor: "name" },
    { Header: "کد آگهی", accessor: "code" },
    { Header: "تاریخ", accessor: "date" },
    { Header: "وضعیت", accessor: "status" },
    { Header: "جزییات کالا", accessor: "detail" },
  ];

  const getdata = useCallback(() => {
    debugger;
    axios
      .get(
        `${baseURL}product/panel/list/${"?search=" + searchinput}${
          activestatus?.id === 0
            ? "&new=true"
            : activestatus?.id === 1
            ? "&active=true"
            : activestatus?.id === 2
            ? "&active=false"
            : ""
        }`,
        header
      )
      .then((res) => {
        console.log(res.data);
        setNext(res.data.next);
        setData(res.data.results);
        // setShowFilter(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [header, searchinput, activestatus]);
  useEffect(() => {
    getdata();
  }, [getdata]);

  const getNextList = () => {
    debugger;
    if (next != null) {
      axios
        .get(next, header)
        .then((res) => {
          console.log("res", res.data);
          setData([...data, ...res.data.results]);
          setNext(res.data.next);
        })
        .catch((err) => {
          console.log("err", err.response);
        });
    }
  };

  useEffect(() => {
    debugger;
    // console.log(state);
    const newArray = [];
    for (let i = 0; i < data?.length; i++) {
      const tr = data[i];
      newArray.push({
        title: tr?.name,
        name: tr?.user?.first_name + " " + tr?.user?.last_name,
        code: tr?.id,
        date: moment(tr?.created_time).locale("fa").format("YYYY/MM/DD"),
        status: tr?.is_active ? (
          <div className='color-green2'>فعال</div>
        ) : (
          <div className='color-red'>غیرفعال</div>
        ),
        detail: (
          <>
            <img
              className='mx-auto cursor-pointer'
              src='/statics/images/eye.png'
              width='20'
              alt='eye'
              onClick={() => {
                history.push("/adsdetail/" + tr?.id);
              }}
            />
          </>
        ),
      });
    }

    setRows(newArray);
  }, [data, history]);

  return (
    <div>
      <div className='flex justify-end items-center gap-3 h-16 mb-8'>
        {/* search */}
        <div
          className={`m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center${
            issearchinput ? "flex justify-between items-center w-64" : ""
          } `}
        >
          {issearchinput && (
            <input
              // className='transition-all'
              placeholder='جست و جوی کالا'
              defaultValue={searchinput}
              // value={filters?.search}
              onChange={(e) => {
                const { value } = e.target;
                setSearchinput(value);
              }}
            />
          )}
          <img
            // className='transition-all'
            src='/statics/images/search.svg'
            width='16'
            alt='eye'
            onClick={() => {
              setIsSearchinput(!issearchinput);
            }}
          />
        </div>

        {/* bell */}
        <div className='m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8 flex justify-center items-center'>
          <img
            className=''
            src='/statics/images/bell.svg'
            width='16'
            alt='bell'
          />
        </div>
      </div>

      {/* filter */}
      <div className='grid grid-cols-3 rounded-xl shadow-default max-w-md mx-auto  mb-10'>
        {status?.map((row) => (
          <div
            key={row.id}
            className={`flex justify-center items-center cursor-pointer py-2 px-2 ${
              activestatus?.id === row?.id ? "bg-gray-200" : "bg-white"
            } ${
              row.id === 0 ? "rounded-r-xl" : row.id === 2 ? "rounded-l-xl" : ""
            }`}
            onClick={() => {
              if (activestatus?.id === row?.id) setActivestatus(null);
              else setActivestatus(row);
            }}
          >
            <div className='flex items-center justify-center '>
              <span className='font-semibold' style={{ color: row?.color }}>
                {row?.title}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className='rounded-lg shadow mx-1 p-2'>
        <InfiniteScroll
          className='w-100'
          dataLength={data?.length}
          next={() => getNextList()}
          hasMore={true}
          scrollableTarget='scrollableDiv'
        >
          <div
            className='overflow-y-scroll scroll-style pr-2 ltr h-full'
            id='scrollableDiv'
            style={{ height: "60vh" }}
          >
            <div className='rtl m-5 md:m-0'>
              <Table
                classs='paneltable UsersTable'
                columns={columns}
                data={rows}
                hasSpace
              />
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default Ads;
